<script>
import baseMixin from '@/mixins/baseMixin'
import { FormFieldType } from '@/constants/form/FormFieldType'
import { FormField } from '@/models/forms/fields/formField'
import FormSubmissionImageField from './form-submission-image-field.vue'
import FormSubmissionStarRatingField from './form-submission-star-rating-field.vue'
import FormSubmissionContentField from './form-submission-content-field.vue'
import FormSubmissionDefaultField from './form-submission-default-field.vue'
import FormSubmissionDateField from './form-submission-date-field.vue'
import FormSubmissionDatetimeField from './form-submission-datetime-field.vue'
import FormSubmissionYesNoField from './form-submission-yes-no-field.vue'
import FormSubmissionSelectBoxField from './form-submission-select-box-field.vue'
import FormSubmissionCheckboxField from './form-submission-checkbox-field.vue'
import FormSubmissionSelectField from './form-submission-select-field.vue'
import FormSubmissionRadioField from './form-submission-radio-field.vue'

export default {
  name: 'FormSubmissionFieldControl',
  mixins: [baseMixin],
  props: {
    field: {
      type: FormField,
      required: true,
    },
    value: {
      required: true,
    },
  },
  computed: {
    formValueControlDefinition() {
      switch (this.field.fieldType) {
        case FormFieldType.Content:
          return this.formValueControlFactory(FormSubmissionContentField)
        case FormFieldType.Checkbox:
          return this.formValueControlFactory(FormSubmissionCheckboxField)
        case FormFieldType.Date:
          return this.formValueControlFactory(FormSubmissionDateField)
        case FormFieldType.DateTime:
          return this.formValueControlFactory(FormSubmissionDatetimeField)
        case FormFieldType.Radio:
          return this.formValueControlFactory(FormSubmissionRadioField, -1)
        case FormFieldType.Select:
          return this.formValueControlFactory(FormSubmissionSelectField, -1)
        case FormFieldType.SelectBox:
          return this.formValueControlFactory(FormSubmissionSelectBoxField, {})
        case FormFieldType.Signature:
          return this.formValueControlFactory(FormSubmissionImageField, '')
        case FormFieldType.StarRating:
          return this.formValueControlFactory(FormSubmissionStarRatingField, -1)
        case FormFieldType.YesNo:
          return this.formValueControlFactory(FormSubmissionYesNoField)
        default:
          return this.formValueControlFactory(FormSubmissionDefaultField, '')
      }
    },
  },
  methods: {
    formValueControlFactory(component, defaultValue = null, extraProps = {}) {
      return {
        component,
        props: {
          field: this.field,
          ...extraProps,
          value: this.value || defaultValue,
        },
        events: {},
      }
    },
  },
}
</script>

<template>
  <component
    :is="formValueControlDefinition.component"
    v-if="formValueControlDefinition"
    data-testid="form-value-control-component"
    :data-type="field.fieldType"
    v-bind="formValueControlDefinition.props"
    v-on="formValueControlDefinition.events"
  />
</template>
